(function () {
    'use strict';
    var m = angular.module('gui-v2');
    m.directive('dashboardEventsStatistic', ["$timeout", "path", "$q", "modulesManager", "securityEventsDao", "timeResolutions", "routeHelper", "base64", "dashboardWidgetDao", "$location", "odometerFormat", "feature", "policyInfoBoxesHelper", "securityEventTypes", function ($timeout, path, $q, modulesManager, securityEventsDao, timeResolutions, routeHelper, base64, dashboardWidgetDao, $location, odometerFormat, feature, policyInfoBoxesHelper, securityEventTypes) {
        return {
            restrict: 'A',
            replace: false,
            templateUrl: path('gui-v2').directive('dashboard/events-statistic').template('events-statistic'),
            transclude: { right: '?right' },
            scope: { resolution: '=' },
            link: function ($scope) {
                $scope.widgetApi = {};
                $scope.widgets = [];
                $scope.$watch('resolution', function (newVal, oldVal) {
                    if (oldVal !== newVal) {
                        _($scope.widgets).each(function (widget) {
                            widget.loading = true;
                        });
                        $scope.shadowItSecondaryData = null;
                        $scope.widgetApi.reload(true);
                    }
                });
                $scope.expandedWidgets = {};
                var SetCacheDataTimeout = 7000;
                var maxShadowItApps = 20;
                var shadowItAppsCount = 4;
                var expandedSaaSCount = 4;
                var saasHeight = 23;
                var widgetId = 'events-statistic';
                var numOfDashboardWidgets = feature.numOfDashboardWidgets || 5;
                var phishingSubItems = ['suspicious_phishing'];
                if (feature.showSpam) {
                    phishingSubItems.push('spam');
                }
                if (feature.showMarketing) {
                    phishingSubItems.push('marketing');
                }
                var allWidgets = [
                    'malware',
                    'phishing',
                    'shadow_it',
                    'dlp',
                    'anomaly',
                    'alert',
                    'threat_extraction'
                ];
                var blacklistedWidgets = [
                    'shadow_it',
                    'dlp'
                ];
                var defaultWidgets = [];
                var filterStates = [
                    'new',
                    'remediated',
                    'detected'
                ];
                var allwidgetsDef = {
                    malware: {
                        label: 'Malware',
                        baseType: 'malware',
                        categories: [
                            'malware',
                            'suspicious_malware'
                        ],
                        generator: function (data) {
                            var result = standardGenerator.call(this, data);
                            if (!feature.checkpointTheme && data) {
                                result.rightArray = [];
                                // Add suspicious_malware substate
                                var type = 'suspicious_malware';
                                eventsCount = count(data.eventsResolutionResponse, { type: type });
                                remediatedCount = count(data.eventsResolutionResponse, {
                                    type: type,
                                    state: 'remediated'
                                });
                                result.rightArray.push({
                                    name: type,
                                    label: 'Suspicious',
                                    count: eventsCount,
                                    countF: odometerFormat(eventsCount),
                                    href: createHref([type], $scope.resolution, filterStates),
                                    tooltip: tipContent(eventsCount, remediatedCount, type)
                                });
                                // Add malware substate
                                var eventsCount = count(data.eventsResolutionResponse, { type: 'malware' });
                                var remediatedCount = count(data.eventsResolutionResponse, {
                                    type: 'malware',
                                    state: 'remediated'
                                });
                                var tooltipText = tipContent(eventsCount, remediatedCount, type);
                                result.rightArray.push({
                                    name: 'malware',
                                    label: securityEventTypes.get('malware').label,
                                    count: eventsCount,
                                    countF: odometerFormat(eventsCount),
                                    href: createHref(['malware'], $scope.resolution, filterStates),
                                    tooltip: tooltipText
                                });
                            }
                            return result;
                        }
                    },
                    phishing: {
                        label: 'Phishing',
                        baseType: 'phishing',
                        categories: ['phishing'],
                        generator: function (data) {
                            var result = standardGenerator.call(this, data);
                            if (!feature.checkpointTheme && data) {
                                result.rightArray = _(phishingSubItems).chain().map(function (type) {
                                    var eventsCount = count(data.eventsResolutionResponse, { type: type });
                                    var remediatedCount = count(data.eventsResolutionResponse, {
                                        type: type,
                                        state: 'remediated'
                                    });
                                    if (!eventsCount) {
                                        return;
                                    }
                                    var tip = {
                                        position: {
                                            at: 'bottom center',
                                            my: 'top center'
                                        },
                                        content: {}
                                    };
                                    if (eventsCount === remediatedCount) {
                                        tip.content.text = 'All events remediated';
                                    } else {
                                        if (remediatedCount > 0) {
                                            tip.content.text = formatNumber(remediatedCount) + ' out of ' + formatNumber(eventsCount) + ' (' + Math.floor(100 * remediatedCount / eventsCount) + '%) remediated';
                                        } else {
                                            tip.content.text = formatNumber(eventsCount) + (type === 'suspicious_phishing' ? ' events require your attention' : ' ' + type + ' email' + (eventsCount > 1 ? 's' : '') + ' detected');
                                        }
                                    }
                                    return {
                                        name: type,
                                        label: type === 'suspicious_phishing' ? 'Suspicious' : securityEventTypes.get(type).label,
                                        count: eventsCount,
                                        countF: odometerFormat(eventsCount),
                                        href: createHref([type], $scope.resolution, filterStates),
                                        tooltip: tip
                                    };
                                }).compact().value();
                            }
                            return result;
                        }
                    },
                    shadow_it: {
                        label: 'Shadow IT',
                        baseType: 'shadow_it',
                        categories: ['shadow_it'],
                        generator: function (data) {
                            var result = standardGenerator.call(this, data, 'approved');
                            if (feature.showOldShadowIt) {
                                result.titleHref = routeHelper.getHref('analytics', { page: 'shadow-it' });
                            } else {
                                result.titleHref = routeHelper.getHref('shadow-it');
                            }
                            result.allHref = result.titleHref;
                            if (!data || !data.shadowItLoaded) {
                                return result;
                            }
                            var showAppsAmount = shadowItAppsCount;
                            if (data.shadowItPrimaryResponse && data.shadowItPrimaryResponse.length > shadowItAppsCount) {
                                showAppsAmount -= 1;
                            }
                            result.shadowItApps = _(data.shadowItPrimaryResponse).map(function (row) {
                                var totalCount = $scope.shadowItSecondaryData ? $scope.shadowItSecondaryData[row.shadow_it_application] || 0 : '';
                                var resolutionCount = row.count || 0;
                                var remediatedCount = row.remediated || 0;
                                var remediatedPerCent = resolutionCount ? Math.floor(100 * remediatedCount / resolutionCount) : 0;
                                var txt = '';
                                if (resolutionCount === remediatedCount) {
                                    txt = 'All ' + row.shadow_it_application + ' events approved';
                                } else {
                                    if (remediatedCount === 0) {
                                        txt = resolutionCount + ' users are using ' + row.shadow_it_application;
                                    } else {
                                        txt = formatNumber(remediatedCount) + ' out of ' + formatNumber(resolutionCount) + ' (' + remediatedPerCent + '%) ' + row.shadow_it_application + ' events approved';
                                    }
                                }
                                var newCount = resolutionCount - remediatedCount;
                                if (newCount < 0) {
                                    newCount = 0;
                                }
                                return {
                                    name: row.shadow_it_application,
                                    label: row.shadow_it_application,
                                    totalCount: totalCount,
                                    totalCountF: $scope.shadowItSecondaryData ? odometerFormat(totalCount) : '',
                                    totalCountClass: $scope.shadowItSecondaryData ? '' : 'fa fa-spinner fa-pulse',
                                    totalCountHref: createHref(['shadow_it'], 'all', null, null, { shadow_it_application: [row.shadow_it_application] }),
                                    resolutionLabel: timeResolutions.get($scope.resolution).label,
                                    resolutionCount: resolutionCount,
                                    resolutionCountF: odometerFormat(resolutionCount),
                                    resolutionHref: createHref(['shadow_it'], $scope.resolution, null, null, { shadow_it_application: [row.shadow_it_application] }),
                                    newCountF: odometerFormat(newCount),
                                    newAndDetectedCountF: odometerFormat(newCount),
                                    tip: {
                                        content: { text: txt },
                                        position: {
                                            at: 'bottom center',
                                            my: 'top center'
                                        }
                                    }
                                };
                            });
                            result.saasStaticMoreText = '';
                            result.totalApps = data.shadowItTotalApps;
                            if (data.shadowItSecondaryQuery) {
                                data.shadowItSecondaryQuery.then(function (results) {
                                    $scope.shadowItSecondaryData = results;
                                    var shadowItWidget = _($scope.widgets).find(function (widget) {
                                        return widget.widgetType === 'shadow_it';
                                    });
                                    if (shadowItWidget) {
                                        _(shadowItWidget.shadowItApps).each(function (app) {
                                            app.totalCount = results && results[app.name] || 0;
                                            app.totalCountF = odometerFormat(app.totalCount);
                                            app.totalCountClass = '';
                                        });
                                    }
                                });
                            }
                            return result;
                        }
                    },
                    dlp: {
                        label: 'DLP',
                        baseType: 'dlp',
                        categories: ['dlp'],
                        generator: standardGenerator
                    },
                    anomaly: {
                        label: 'Anomalies',
                        baseType: 'anomaly',
                        categories: ['anomaly'],
                        generator: standardGenerator
                    },
                    alert: {
                        label: 'Alert',
                        baseType: 'alert',
                        categories: ['alert'],
                        generator: standardGenerator
                    },
                    threat_extraction: {
                        label: 'Threat Extraction',
                        baseType: 'threat_extraction',
                        categories: ['threat_extraction'],
                        generator: standardGenerator
                    }
                };
                var widgetsDef = {};
                // var activeSecApps = modulesManager.activeSecApps() || [];
                function createPath(types, resolution, states, saas, moreFilters) {
                    var filters = [];
                    if (types) {
                        _(types).each(function (type) {
                            filters.push({
                                type: 'type',
                                id: type
                            });
                        });
                    }
                    if (saas) {
                        filters.push({
                            type: 'saas',
                            id: saas
                        });
                    }
                    if (!states || states.length === 0) {
                        states = filterStates;
                    }
                    _(states).each(function (state) {
                        filters.push({
                            type: 'current_state',
                            id: state
                        });
                    });
                    if (moreFilters) {
                        _(moreFilters).each(function (values, filterType) {
                            _(values).each(function (value) {
                                filters.push({
                                    type: filterType,
                                    id: value
                                });
                            });
                        });
                    }
                    var qs = {
                        filters: base64.encode(JSON.stringify({
                            resolution: resolution,
                            filters: filters,
                            filterBy: ''
                        }))
                    };
                    return routeHelper.getPath('security-events', {}, qs);
                }
                function createHref(types, resolution, states, saas, moreFilters) {
                    return routeHelper.pathToHref(createPath(types, resolution, states, saas, moreFilters));
                }
                function count(events, filter) {
                    return _(events).chain().filter(function (row) {
                        return (!filter.type || row.type === filter.type) && (!filter.types || !Array.isArray(filter.types) || filter.types.includes(row.type)) && (!filter.state || row.current_state === filter.state) && (!filter.saas || row.saas === filter.saas);
                    }).reduce(function (memo, row) {
                        return memo + (row.count || 0);
                    }, 0).value();
                }
                function formatNumber(n) {
                    try {
                        return n.toLocaleString('en-US');
                    } catch (e) {
                        return '' + n;
                    }
                }
                function tipContent(eventsCount, remediatedCount, eventType) {
                    var tip = {
                        position: {
                            at: 'bottom center',
                            my: 'top center'
                        },
                        content: {}
                    };
                    if (eventsCount === remediatedCount) {
                        tip.content.text = 'All events remediated';
                    } else {
                        var type = eventType || '';
                        if (remediatedCount > 0) {
                            tip.content.text = formatNumber(remediatedCount) + ' out of ' + formatNumber(eventsCount) + ' (' + Math.floor(100 * remediatedCount / eventsCount) + '%) remediated';
                        } else {
                            tip.content.text = formatNumber(eventsCount) + (type && type.indexOf('suspicious') !== -1 ? ' events require your attention' : ' ' + type + ' email' + (eventsCount > 1 ? 's' : '') + ' detected');
                        }
                    }
                    return tip;
                }
                function calculateSaaSesHeight(result) {
                    if (result.saass.length > expandedSaaSCount) {
                        result.saassCollapsedHeight = expandedSaaSCount * saasHeight + 'px';
                        result.saassExpandedHeight = (result.saass.length + 1) * saasHeight + 'px';
                        result.saassExpandable = true;
                        result.saassMoreText = 'and ' + (result.saass.length - expandedSaaSCount + 1) + ' more';
                    } else {
                        result.saassCollapsedHeight = 'auto';
                        result.saassExpandedHeight = result.saassCollapsedHeight;
                        result.saassExpandable = false;
                    }
                }
                function baseEvents(label, type, categories, widgetType, data, remediatedWord) {
                    if (!remediatedWord) {
                        remediatedWord = 'remediated';
                    }
                    var result = {};
                    result.widgetType = widgetType;
                    result.iconClass = securityEventTypes.get(type).iconClass;
                    result.label = label;
                    result.allHref = createHref(categories, $scope.resolution);
                    result.titleHref = result.allHref;
                    result.expandedText = '';
                    if (!data) {
                        result.loading = true;
                        result.isEmpty = true;
                        return result;
                    }
                    result.loading = false;
                    result.isEmpty = false;
                    var eventsTotalResponse = data.eventsTotalResponse;
                    var eventsResolutionResponse = data.eventsResolutionResponse;
                    var saass = data.saass;
                    result.allCountLabel = 'Total';
                    result.allCount = count(eventsResolutionResponse, { types: categories });
                    result.allCountF = odometerFormat(result.allCount);
                    result.newCountLabel = 'Pending';
                    result.newCount = count(eventsResolutionResponse, {
                        types: categories,
                        state: 'new'
                    });
                    result.newCountF = odometerFormat(result.newCount);
                    result.remediatedLabel = remediatedWord;
                    result.detectedCountLabel = 'Detected';
                    result.detectedCount = count(eventsResolutionResponse, {
                        types: categories,
                        state: 'detected'
                    });
                    result.detectedCountF = odometerFormat(result.detectedCount);
                    result.newAndDetectedCountF = odometerFormat(result.newCount + result.detectedCount);
                    result.remediatedCount = count(eventsResolutionResponse, {
                        types: categories,
                        state: 'remediated'
                    });
                    result.remediatedPerCent = result.allCount ? Math.floor(100 * result.remediatedCount / result.allCount) : 0;
                    result.remediatedPath = createPath(categories, $scope.resolution, ['remediated']);
                    if (result.newCount === 0) {
                        result.remediationStatus = 'good';
                        result.newHref = createHref(categories, $scope.resolution, ['remediated']);
                    } else {
                        result.remediationStatus = 'bad';
                        result.newHref = createHref(categories, $scope.resolution, ['new']);
                    }
                    if (type === 'shadow_it') {
                        result.hideRemediated = true;
                    }
                    result.detectedHref = createHref(categories, $scope.resolution, ['detected']);
                    result.statusClass = {};
                    result.statusClass['status-' + result.remediationStatus] = true;
                    result.allTip = {
                        content: {},
                        position: {
                            at: 'bottom center',
                            my: 'top center'
                        }
                    };
                    result.newTip = {
                        content: {},
                        position: {
                            at: 'bottom center',
                            my: 'top center'
                        }
                    };
                    result.emptyTip = {
                        content: { text: 'No ' + result.label + ' events' },
                        position: {
                            at: 'bottom center',
                            my: 'top center'
                        }
                    };
                    if (result.newCount === 0) {
                        result.newTip.content.text = 'All events ' + remediatedWord;
                        result.allTip.content.text = 'All events ' + remediatedWord;
                    } else {
                        result.newTip.content.text = formatNumber(result.newCount) + ' events require your attention';
                        if (result.newCount === result.allCount) {
                            result.allTip.content.text = formatNumber(result.newCount) + ' events require your attention';
                        } else {
                            result.allTip.content.text = formatNumber(result.remediatedCount) + ' out of ' + formatNumber(result.allCount) + ' (' + result.remediatedPerCent + '%) ' + remediatedWord;
                        }
                    }
                    result.saass = _(saass).chain().map(function (saas) {
                        var totalCount = count(eventsTotalResponse, {
                            types: categories,
                            saas: saas.name
                        });
                        var resolutionCount = count(eventsResolutionResponse, {
                            types: categories,
                            saas: saas.name
                        });
                        var newCount = count(eventsResolutionResponse, {
                            types: categories,
                            saas: saas.name,
                            state: 'new'
                        });
                        var remediatedCount = count(eventsResolutionResponse, {
                            types: categories,
                            saas: saas.name,
                            state: 'remediated'
                        });
                        var remediatedPerCent = resolutionCount ? Math.floor(100 * remediatedCount / resolutionCount) : 0;
                        var detectedCount = count(eventsResolutionResponse, {
                            types: categories,
                            saas: saas.name,
                            state: 'detected'
                        });
                        var txt = '';
                        if (newCount === 0) {
                            txt = 'All ' + (saas.label_short || saas.title) + ' events ' + remediatedWord;
                        } else {
                            if (remediatedCount === 0) {
                                txt = newCount + ' ' + (saas.label_short || saas.title) + ' events require your attention';
                            } else {
                                txt = formatNumber(remediatedCount) + ' out of ' + formatNumber(resolutionCount) + ' (' + remediatedPerCent + '%) ' + (saas.label_short || saas.title) + ' events ' + remediatedWord;
                            }
                        }
                        return {
                            name: saas.name,
                            label: saas.label_short || saas.title,
                            totalCount: totalCount,
                            totalCountF: odometerFormat(totalCount),
                            totalHref: createHref(categories, 'all', null, saas.name),
                            resolutionLabel: timeResolutions.get($scope.resolution).label,
                            resolutionCount: resolutionCount,
                            resolutionCountF: odometerFormat(resolutionCount),
                            resolutionHref: createHref(categories, $scope.resolution, null, saas.name),
                            newCountF: odometerFormat(newCount),
                            newAndDetectedCountF: odometerFormat(newCount + detectedCount),
                            newAndDetectedHref: createHref(categories, $scope.resolution, [
                                'new',
                                'detected'
                            ], saas.name),
                            tip: {
                                content: { text: txt },
                                position: {
                                    at: 'bottom center',
                                    my: 'top center'
                                }
                            }
                        };
                    }).filter(function (info) {
                        return info.resolutionCount;
                    }).sortBy(function (info) {
                        return -info.resolutionCount;
                    }).value();
                    calculateSaaSesHeight(result);
                    if (result.widgetType == 'dlp') {
                        result.newHref = createHref(categories, $scope.resolution, ['new']);
                        result.remediatedHref = createHref(categories, $scope.resolution, ['remediated']);
                        result.detectedHref = createHref(categories, $scope.resolution, ['detected']);
                        result.newTip = {
                            content: { text: 'You have ' + result.newCount + ' pending events' },
                            position: {
                                at: 'bottom center',
                                my: 'top center'
                            }
                        };
                        result.remediatedTip = {
                            content: { text: result.remediatedCount + ' events have been remediated' },
                            position: {
                                at: 'bottom center',
                                my: 'top center'
                            }
                        };
                        result.detectedTip = {
                            content: { text: 'You have ' + result.detectedCount + ' leaked events' },
                            position: {
                                at: 'bottom center',
                                my: 'top center'
                            }
                        };
                    }
                    return result;
                }
                function standardGenerator(data, remediatedWord) {
                    return baseEvents(this.label, this.baseType, this.categories, this.widgetType, data, remediatedWord);
                }
                _(allWidgets).each(function (widget) {
                    if (widget === 'dlp' && feature.lastlineTheme || widget === 'anomaly' && feature.hideAnomalyEvents || widget === 'threat_extraction' && !feature.checkpointTheme) {
                        return;
                    }
                    defaultWidgets.push(widget);
                    allwidgetsDef[widget].widgetType = widget;
                    widgetsDef[widget] = angular.copy(allwidgetsDef[widget]);
                });
                if (feature.sonicwallTheme && widgetsDef.shadow_it) {
                    widgetsDef.shadow_it.label = 'Shadow SaaS';
                }
                function updateShadowItWidget() {
                    var shadowItWidget, maxSaaSes = 0;
                    _($scope.widgets).each(function (widget) {
                        if (widget.widgetType === 'shadow_it') {
                            shadowItWidget = widget;
                        } else {
                            if (widget.saass && widget.saass.length > maxSaaSes) {
                                maxSaaSes = widget.saass.length;
                            }
                        }
                    });
                    if (shadowItWidget && shadowItWidget.shadowItApps) {
                        shadowItWidget.saasStaticMoreText = '';
                        shadowItWidget.expandedText = '';
                        shadowItWidget.collapsedText = '';
                        if (shadowItWidget.shadowItApps.length <= expandedSaaSCount) {
                            shadowItWidget.saass = shadowItWidget.shadowItApps;
                        } else {
                            var showAmount;
                            if (maxSaaSes <= expandedSaaSCount) {
                                showAmount = expandedSaaSCount - 1;
                                shadowItWidget.saasStaticMoreText = 'and ' + (shadowItWidget.totalApps - showAmount) + ' more';
                            } else {
                                shadowItWidget.collapsedText = 'and ' + (shadowItWidget.totalApps - expandedSaaSCount + 1) + ' more';
                                if (maxSaaSes >= shadowItWidget.shadowItApps.length) {
                                    showAmount = shadowItWidget.shadowItApps.length;
                                } else {
                                    showAmount = maxSaaSes;
                                    shadowItWidget.expandedText = 'and ' + (shadowItWidget.totalApps - showAmount) + ' more';
                                }
                            }
                            shadowItWidget.saass = _(shadowItWidget.shadowItApps).first(showAmount);
                        }
                        calculateSaaSesHeight(shadowItWidget);
                        shadowItWidget.saassMoreText = shadowItWidget.collapsedText;
                    }
                }
                function validateEventsStatisticData(data) {
                    if (!data) {
                        return;
                    }
                    function validatePositiveCount(item) {
                        item.count = item.count >= 0 ? item.count : 0;
                    }
                    data.eventsResolutionResponse.forEach(validatePositiveCount);
                    data.eventsTotalResponse.forEach(validatePositiveCount);
                }
                function generateStatWidget(widgetType, data) {
                    validateEventsStatisticData(data);
                    return widgetsDef[widgetType].generator(data);
                }
                function updateStatWidget(oldWidget, newWidget) {
                    if (!oldWidget || oldWidget.widgetType !== newWidget.widgetType) {
                        return newWidget;
                    }
                    var arrays = [
                        'saass',
                        'rightArray',
                        'shadowItApps'
                    ];
                    $.extend(oldWidget, _(newWidget).omit(arrays));
                    _(arrays).each(function (field) {
                        if (!newWidget[field]) {
                            delete oldWidget[field];
                            return;
                        }
                        if (!oldWidget[field] && newWidget[field] || oldWidget[field].length !== newWidget[field].length || _(newWidget[field]).find(function (data, idx) {
                                return data.name !== oldWidget[field][idx].name;
                            })) {
                            oldWidget[field] = newWidget[field];
                        } else {
                            _(oldWidget[field]).each(function (data, idx) {
                                $.extend(data, newWidget[field][idx]);
                            });
                        }
                    });
                    return oldWidget;
                }
                function updateStatWidgets(data) {
                    $scope.widgets = _($scope.widgets).map(function (widget) {
                        var replaceOptions = widget.replaceOptions;
                        if (widgetsDef[widget.widgetType]) {
                            widget = updateStatWidget(widget, generateStatWidget(widget.widgetType, data));
                            widget.replaceOptions = replaceOptions;
                        }
                        return widget;
                    });
                    updateShadowItWidget();
                }
                function replaceWidget(idx, newWidgetType) {
                    if (!$scope.visibleWidgets.length || $scope.visibleWidgets.length <= idx) {
                        return;
                    }
                    $scope.visibleWidgets[idx] = newWidgetType;
                    dashboardWidgetDao.save(widgetId, { visibleWidgets: $scope.visibleWidgets });
                    updateWidgets(true);
                }
                function hideWidget(idx, widgetType) {
                    if (!$scope.visibleWidgets.length || $scope.visibleWidgets.length <= idx) {
                        return;
                    }
                    $scope.visibleWidgets = _($scope.visibleWidgets).reject(function (widget) {
                        return widget === widgetType;
                    });
                    dashboardWidgetDao.save(widgetId, { visibleWidgets: $scope.visibleWidgets });
                    updateWidgets(true);
                }
                function closeOpenedMenu() {
                    var $toggleElement = $('.widget-settings.open');
                    if ($toggleElement && $toggleElement.length) {
                        $toggleElement.removeClass('open');
                        $toggleElement.find('[aria-expanded=true]').attr('aria-expanded', false);
                    }
                }
                function showDefaultWidgets() {
                    $scope.visibleWidgets = [];
                    widgetsDef = {};
                    _(defaultWidgets).each(function (widget) {
                        if ($scope.visibleWidgets.length < numOfDashboardWidgets) {
                            $scope.visibleWidgets.push(widget);
                        }
                        widgetsDef[widget] = angular.copy(allwidgetsDef[widget]);
                    });
                    dashboardWidgetDao.save(widgetId, { visibleWidgets: $scope.visibleWidgets });
                    updateWidgets(true);
                    // close dropdown-toggle
                    closeOpenedMenu();
                }
                function getInfoboxId(row, pos) {
                    return 'ui2-info-' + row + '-' + pos;
                }
                var infoboxesPositions = [
                    'top',
                    'bottom'
                ];
                function updateWidgets(noReload) {
                    var inactiveStatWidgets = _(widgetsDef).chain().keys().difference($scope.visibleWidgets).value();
                    var loadStats = false;
                    var loadShadowIt = false;
                    var loadInfoboxesIds = [];
                    var queries = [];
                    $scope.widgets = _($scope.visibleWidgets).map(function (widgetType, idx) {
                        var widget = $scope.widgets && $scope.widgets[idx];
                        if (widgetsDef[widgetType]) {
                            loadStats = true;
                            if (!widget || widget.widgetType !== widgetType) {
                                widget = updateStatWidget(widget, generateStatWidget(widgetType, $scope.statisticsData));
                            }
                        } else {
                            if (!widget || widget.widgetType !== widgetType) {
                                widget = {
                                    widgetType: widgetType,
                                    loading: true,
                                    isEmpty: true
                                };
                            }
                        }
                        if (widgetType === 'shadow_it') {
                            loadShadowIt = true;
                        }
                        widget.replaceOptions = inactiveStatWidgets.map(function (widgetType) {
                            return {
                                text: 'Replace with ' + widgetsDef[widgetType].label,
                                disabled: function () {
                                    return false;
                                },
                                execute: function () {
                                    replaceWidget(idx, widgetType);
                                }
                            };
                        });
                        if (widgetType === 'infoboxes') {
                            _(infoboxesPositions).each(function (pos) {
                                loadInfoboxesIds.push(getInfoboxId(idx, pos));
                            });
                        }
                        if (widget.widgetType !== 'infoboxes') {
                            widget.replaceOptions.push({
                                text: 'Replace with Custom query',
                                disabled: function () {
                                    return false;
                                },
                                execute: function () {
                                    replaceWidget(idx, 'infoboxes');
                                }
                            });
                        }
                        var additionalReplaceOptions = [
                            {
                                text: 'Hide',
                                disabled: function () {
                                    return _(blacklistedWidgets).findIndex(function (widget) {
                                        return widget === widgetType;
                                    }) === -1;
                                },
                                execute: function () {
                                    if (_(blacklistedWidgets).findIndex(function (widget) {
                                            return widget === widgetType;
                                        }) === -1) {
                                        return;
                                    }
                                    hideWidget(idx, widgetType);
                                }
                            },
                            {
                                text: 'Reset to default',
                                disabled: function () {
                                    return false;
                                },
                                execute: function () {
                                    showDefaultWidgets();
                                }
                            }
                        ];
                        widget.replaceOptions = widget.replaceOptions.concat(additionalReplaceOptions);
                        return widget;
                    });
                    updateShadowItWidget();
                    if (loadStats) {
                        if (!noReload || !$scope.statisticsData || !$scope.statisticsData.shadowItLoaded && loadShadowIt) {
                            queries.push(loadStatisticsData(loadShadowIt).then(function (results) {
                                $scope.live_stats_loaded = true;
                                $scope.statisticsData = results;
                                return updateStatWidgets(results);
                            }));
                            if (!$scope.cached_stats_loaded && feature.preloadCachedStats) {
                                queries.push(loadStatisticsData(loadShadowIt, true).then(function (results) {
                                    $scope.cached_stats_loaded = true;
                                    $timeout(function () {
                                        if (!$scope.live_stats_loaded) {
                                            $scope.statisticsData = results;
                                            return updateStatWidgets(results);
                                        }
                                    }, SetCacheDataTimeout);
                                }));
                            }
                        }
                    } else {
                        $scope.statisticsData = null;
                    }
                    if (loadInfoboxesIds.length) {
                        queries.push(loadInfoboxesData(loadInfoboxesIds).then(function (results) {
                            $scope.infoboxesData = results;
                            updateInfoboxesWidgets(results);
                        }));
                    }
                    return $q.all(queries);
                }
                var getWidgets = function (temporaryWidgets) {
                    var widgets = angular.copy(temporaryWidgets);
                    widgets = _(widgets).reject(function (widget) {
                        return !widgetsDef[widget] && widget !== 'infoboxes';
                    });
                    if (numOfDashboardWidgets < widgets.length) {
                        widgets = widgets.slice(0, numOfDashboardWidgets);
                    }
                    // var inactiveStatWidgets = _(widgetsDef).chain().keys().difference(widgets).value();
                    // if (numOfDashboardWidgets > widgets.length) {
                    //     inactiveStatWidgets = inactiveStatWidgets.slice(0, numOfDashboardWidgets-widgets.length);
                    //     widgets = widgets.concat(inactiveStatWidgets);
                    // } else if (numOfDashboardWidgets < widgets.length) {
                    //     widgets = widgets.slice(0, numOfDashboardWidgets);
                    // }
                    $scope.visibleWidgets = widgets;
                    return updateWidgets();
                };
                var loadTimeout = $q.defer();
                $scope.loadData = function () {
                    loadTimeout.resolve();
                    loadTimeout = $q.defer();
                    return dashboardWidgetDao.retrieve(widgetId).timeout(loadTimeout.promise).then(function (response) {
                        return getWidgets(response.data.conf && response.data.conf.visibleWidgets || defaultWidgets);
                    });
                };
                var statLoadTimeout = $q.defer();
                function loadStatisticsData(loadShadowIt, loadCachedStatsOnly) {
                    // this line cancels an ongoing request (we don't need to cancel)
                    // statLoadTimeout.resolve();
                    statLoadTimeout = $q.defer();
                    var results = { shadowItLoaded: loadShadowIt };
                    var queries = [
                        modulesManager.refreshStates().then(function () {
                            results.saass = modulesManager.allSaasApps();
                        }),
                        securityEventsDao.stats($scope.resolution).timeout(statLoadTimeout.promise).params({
                            'only_cached': loadCachedStatsOnly ? true : false,
                            'resolutionColumn': 'create_time',
                            'resolutionStep': $scope.resolution,
                            'resolutionFromNow': true,
                            'resolutionMax': 1,
                            'resolutionFields': [
                                'type',
                                'saas',
                                'current_state'
                            ].join(',')
                        }).params({ filterEnum_current_state: filterStates.join(',') }).then(function (response) {
                            results.eventsResolutionResponse = response.data.period_data;
                            $scope.loaded_stats_resolution_live = true;
                        }),
                        securityEventsDao.stats($scope.resolution).timeout(statLoadTimeout.promise).params({
                            'only_cached': loadCachedStatsOnly ? true : false,
                            'groupBy': [
                                'type',
                                'saas',
                                'current_state'
                            ].join(',')
                        }).params({ filterEnum_current_state: filterStates.join(',') }).then(function (response) {
                            results.eventsTotalResponse = response.data.period_data;
                            $scope.loaded_stats_total_live = true;
                        })
                    ];
                    if (loadShadowIt) {
                        queries.push($q.all([
                            securityEventsDao.stats($scope.resolution, true).timeout(statLoadTimeout.promise).params({
                                'only_cached': loadCachedStatsOnly ? true : false,
                                filterEnum_current_state: filterStates.join(','),
                                filterEnum_type: 'shadow_it',
                                'afterColumn': 'create_time',
                                'afterStep': $scope.resolution,
                                'afterFromNow': true,
                                'afterMax': 1,
                                'groupBy': 'shadow_it_application'
                            }).order('count', 'desc').pagination(0, maxShadowItApps),
                            securityEventsDao.stats($scope.resolution, true).timeout(statLoadTimeout.promise).params({
                                'only_cached': loadCachedStatsOnly ? true : false,
                                filterEnum_current_state: 'remediated',
                                filterEnum_type: 'shadow_it',
                                'afterColumn': 'create_time',
                                'afterStep': $scope.resolution,
                                'afterFromNow': true,
                                'afterMax': 1,
                                'groupBy': 'shadow_it_application'
                            }).order('count', 'desc').pagination(0, maxShadowItApps)
                        ]).then(function (response) {
                            results.shadowItPrimaryResponse = response[0].data.shadow_it_data;
                            results.shadowItTotalApps = response[0].data.shadow_it_total_apps;
                            var shadowItApps = _(results.shadowItPrimaryResponse).chain().pluck('shadow_it_application').first(maxShadowItApps).value();
                            results.shadowItSecondaryQuery = securityEventsDao.stats($scope.resolution, true).timeout(statLoadTimeout.promise).params({
                                filterEnum_current_state: filterStates.join(','),
                                filterEnum_shadow_it_application: shadowItApps.join(','),
                                filterEnum_type: 'shadow_it',
                                'groupBy': 'shadow_it_application'
                            }).then(function (res) {
                                return _(res.data.rows).chain().map(function (row) {
                                    return [
                                        row.shadow_it_application,
                                        row.count
                                    ];
                                }).object().value();
                            });
                            _(results.shadowItPrimaryResponse).each(function (object) {
                                _(response[1].data.shadow_it_data).find(function (row) {
                                    if (object.shadow_it_application === row.shadow_it_application) {
                                        object.remediated = row.count;
                                    }
                                });
                            });
                        }));
                    }
                    return $q.all(queries).then(function () {
                        return results;
                    });
                }
                var infoboxesLoadTimeout = $q.defer();
                function loadInfoboxesData(ids) {
                    infoboxesLoadTimeout.resolve();
                    infoboxesLoadTimeout = $q.defer();
                    return dashboardWidgetDao.widgetsWithData(ids, true, true).timeout(infoboxesLoadTimeout.promise).then(function (response) {
                        var tags = [];
                        var policyVariants = _(response.data.policyCatalog).chain().filter(function (row) {
                            return row.policy_name;
                        }).map(function (policy) {
                            tags.push(policy.policy_data.tags);
                            return {
                                id: policy.policy_id,
                                label: policy.policy_name
                            };
                        }).value();
                        var policyTags = _(tags).chain().flatten().compact().unique().value();
                        return {
                            data: response.data.settings,
                            policyVariants: policyVariants,
                            policyTags: policyTags
                        };
                    });
                }
                function generateInfoboxWidget(row, data) {
                    var widget = {
                        widgetType: 'infoboxes',
                        configureOptions: []
                    };
                    widget.widgets = _(infoboxesPositions).map(function (pos) {
                        var id = getInfoboxId(row, pos);
                        var subWidget = {
                            id: id,
                            'class': {}
                        };
                        subWidget['class']['pos-' + pos] = true;
                        var infoboxData = data.data[id] || {};
                        infoboxData.options = policyInfoBoxesHelper.processSettings(id, infoboxData.options, {
                            policyVariants: data.policyVariants,
                            noDefaultTitle: true
                        });
                        subWidget.settings = infoboxData.options;
                        subWidget.title = infoboxData.options.widgetTitle;
                        widget.configureOptions.push({
                            text: 'Configure ' + pos.charAt(0).toUpperCase() + pos.slice(1) + ' Widget...',
                            execute: function () {
                                $scope.configureInfobox(subWidget);
                            }
                        });
                        if (!(infoboxData.policies && infoboxData.policies.length) && (infoboxData.options.conf.rightMode !== 'value' || !(infoboxData.rightData && infoboxData.rightData.policies.length))) {
                            subWidget.isEmpty = true;
                            return subWidget;
                        }
                        var displayData = policyInfoBoxesHelper.makeDisplayData(infoboxData, subWidget.settings.conf);
                        subWidget.leftCount = _.isArray(displayData.leftCount) ? '#' + JSON.stringify(displayData.leftCount[0]) + '#' + JSON.stringify(displayData.leftCount[1]) : '#' + JSON.stringify(displayData.leftCount);
                        subWidget.rightCount = _.isArray(displayData.rightCount) ? '#' + JSON.stringify(displayData.rightCount[0]) + '#' + JSON.stringify(displayData.rightCount[1]) : '#' + JSON.stringify(displayData.rightCount);
                        subWidget.leftLabel = displayData.leftMessageText;
                        subWidget.rightLabel = displayData.rightMessageText;
                        subWidget.rightCountClass = {};
                        subWidget.rightCountClass['uparrow-' + subWidget.settings.conf.uparrow] = true;
                        return subWidget;
                    });
                    widget.label = widget.widgets[0].title;
                    return widget;
                }
                $scope.$on('open-policy', function (event, data) {
                    routeHelper.redirectTo('policy-edit', { id: data.id });
                });
                function updateInfoboxesWidgets(data) {
                    $scope.widgets = _($scope.widgets).map(function (widget, idx) {
                        var replaceOptions = widget.replaceOptions;
                        if (widget.widgetType === 'infoboxes') {
                            widget = generateInfoboxWidget(idx, data);
                            widget.replaceOptions = replaceOptions;
                        }
                        return widget;
                    });
                }
                $scope.configureInfobox = function (subWidget) {
                    policyInfoBoxesHelper.propertiesDialog(subWidget.settings, {
                        policyVariants: $scope.infoboxesData.policyVariants,
                        policyTags: $scope.infoboxesData.policyTags
                    }).then(function (data) {
                        subWidget.loading = true;
                        return dashboardWidgetDao.save(subWidget.id, data).then(function () {
                            updateWidgets(true);
                        });
                    });
                };
                $scope.$on('$locationChangeStart', function () {
                    loadTimeout.resolve();
                    infoboxesLoadTimeout.resolve();
                    statLoadTimeout.resolve();
                });
            }
        };
    }]);
}());